import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import { toLine, getImg, formatRGBA, getformatstruct, getformitemsdata, getformListItemsdatas, bd_decrypt, formateDate, _isMobile } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import mapv2assembly from '@/view/map/customv2/enshizhoumap';
import mappopupv2 from '@/view/map/customv2/enshizhoupop';
import typev2 from '@/components/mapv2/typev2/index';
import pointlistv2 from '@/view/map/customv2/enshizhoulist';
import axios from 'axios';
import { BMapLoader } from '@/utils/bdMap.js';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import routelist from '@/view/map/hdmconfigv2/routelist';
import pData from '@/view/map/customv2/enshizhoudata.js';
import { toStringHDMS } from 'ol/coordinate';
export default {
  name: 'enshizhou',
  components: {
    mapv2assembly,
    mappopupv2,
    typev2,
    pointlistv2,
    routelist
  },
  data() {
    return {
      isMobileflag: false,
      // 移动端判断
      query: '',
      formUserId: '',
      // 最外层样式
      mainStyle: {
        width: '',
        height: '',
        transform: 'scale(1)',
        transformOrigin: '0 0',
        position: 'relative'
      },
      // 除地图以外的数据集合
      mapelem: {
        bg: '',
        logo: '',
        pickey: '',
        golist: 'https://p.ananas.chaoxing.com/star3/origin/3df243657b8ae7d4bd4eccd3446f3639.png',
        bgaudio: ''
      },
      // 除地图以外的样式集合
      modulestyle: {
        logo: '',
        pickey: '',
        type: '',
        list: '',
        visit: '',
        bgaudio: ''
      },
      cTemplateScore: 0,
      popmodeltype: 0,
      // 弹窗默认模板样式
      pointdetail: {},
      popshowflag: false,
      showtype: 1,
      modeltype: 0,
      showlistflag: 1,
      typebtn: [],
      showgolist: false,
      showgolistId: 0,
      cform: {},
      // 非遗项目表单数据
      cformlabel: {},
      // 非遗项目表单结构标题集合
      cformoption: {},
      // 非遗项目表单结构默认选择项值集合
      cformfield: {},
      // 非遗项目表单校验集合
      cstructList: [],
      // 非遗项目表单结构数据
      cpList: [],
      // 添加或编辑非遗项目表单数据时列表
      defaultcform: {},
      // 非遗项目默认form数据
      cformUser: {},
      // 地图配置当前行ID数据
      formatData: {},
      // 地图配置当前行ID 格式化数据
      sList: [],
      // 添加或编辑地图表单数据时列表
      form: {},
      // 地图表单数据
      formlabel: {},
      // 地图表单结构标题集合
      formoption: {},
      // 地图表单结构默认选择项值集合
      formfield: {},
      // 地图表单校验集合
      mapview: {},
      loadingmap: false,
      mapLayers: {},
      mapstyle: {},
      jsonOption: {},
      typeList: [],
      // 分类列表数据
      mapstreetcode: [],
      typeform: {
        formId: '260297',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 分类列表查询字段
      pointform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 点位查询字段集合
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      coordinate: '',
      // 当前点击经纬度
      defaultpointList: [],
      // 点位列表数据
      pointList: [],
      // 点位列表数据

      maprouteList: [],
      // 路线列表数据
      mapcontainer: '',
      routeform: {
        formId: '1626576',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '8cb8793ff32dba9935520c2f7473a33e83825a93035ae6268d91df56c28f60d9',
        orderType: 'asc'
      },
      // 路线查询字段集合
      routePop: false,
      bdmaploaction: {},
      rtypeform: {
        formId: '1626580',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '7e324a759ba7eeb834922850eb694d88cedc5ae94849013a92bd11cd2b9784dd'
      },
      // 路线分类列表查询字段
      rtypeList: [],
      // 路线分类列表数据
      mapTimer: null,
      routeAllSource: [],
      routeAllLen: 0,
      routePoint: [],
      cType: '',
      routejson: {},
      visitform: {
        formId: 'map_visits',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '146f7409beffcce7387a55a86b9f3908f7823c3fe5626184c9149f3cb3a5eefe'
      },
      // 浏览量查询字段
      visitItem: [{
        num: 0
      }],
      mapsenior: {},
      bgaudio: '',
      bgaudioflag: true,
      editorList: [],
      menuList: [],
      id: 1,
      mapculturalList: [],
      defaultmapculturalList: [],
      isMobile: false,
      typeIndex: 1,
      typechildIndex: '',
      allMenuList: [],
      allLoading: true,
      menusearchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'correlation_map',
            'compt': 'selectbox',
            'express': '===',
            'val': ['是']
          }]
        }]
      },
      typeUlFlag: true,
      typeUlzIndex: false,
      whkjSum: [],
      whhdSum: [],
      whssSum: [],
      menuData: [],
      recordType: {},
      // oncehidewhkjFlag: true,
      listFlag: true,
      whkjsumtotal: 0
    };
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  created() {
    this.mapconStyle();
  },
  mounted() {
    this.query = this.$route.query;
    this.formUserId = this.query.formUserId;
    console.log(`this.id`, this.id);
    // 展示页请求相关接口数据
    this.setComonStyle();
    this.getMapData();
    this.$nextTick(() => {
      this.loadBmap();
    });
    this.menuList = pData.menuList;
  },
  methods: {
    ...mapMutations(['SET_MAPSENIOR', 'SET_MAPVIEW', 'SET_MAPFORM', 'SET_MAPFORMITEM', 'SET_MAPSTYLEITEM', 'SET_MAPDRAWLAYER', 'SET_COORDINATE', 'SET_MAPROUTESOURCE']),
    loadBmap() {
      BMapLoader().then(BMap => {
        this.mapTimer = setInterval(() => {
          if (window.BMapGL && window.BMapGL.Map && window.BMapGL.Point) {
            this.mapcontainer = new BMap.Map('bdmap');
            let geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(a => {
              console.log(a);
              this.bdmaploaction.address = a.address;
              this.bdmaploaction.lng = a.point.lng;
              this.bdmaploaction.lat = a.point.lat;
              localStorage.setItem('bdlocation', JSON.stringify(this.bdmaploaction));
            });
            clearInterval(this.mapTimer);
            this.mapTimer = null;
          }
        }, 100);
      });
    },
    mapconStyle() {
      this.mainStyle.width = `${window.innerWidth}px`;
      this.mainStyle.height = `${window.innerHeight}px`;
      if (_isMobile()) {
        this.isMobileflag = true;
        this.typeUlFlag = false;
      }
    },
    percentageChange(scale) {
      this.mainStyle.transform = `scale(${scale})`;
    },
    /**
    * 定位点格式化
    */
    posFormat(val) {
      delete val.ptype;
      delete val.pIndex;
      return val;
    },
    popcolorFormat(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.7)`;
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme1', theme1);
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme07', theme2);
    },
    styleHandle(val) {
      // console.log(`styleHandle`, val)
      this.popmodeltype = val.popStyleIndex === undefined ? this.form.cTemplateScore === 1 ? 1 : 0 : val.popStyleIndex;
      this.modeltype = val.typeStyleIndex === undefined ? 0 : val.typeStyleIndex;
      Object.keys(this.modulestyle).forEach(key => {
        let pos = this.posFormat(val[`${key}pos`] !== undefined ? {
          ...val[`${key}pos`]
        } : {
          ...this.mapv2info.style[`${key}pos`]
        });
        let appPos = {};
        Object.keys(pos).forEach(item => {
          appPos[item] = this.isMobileflag ? `${parseFloat((parseInt(pos[item]) / 2 / 37.5).toFixed(6))}rem` : `${parseFloat((parseInt(pos[item]) / 1920 * 100).toFixed(6))}vw`;
        });
        this.modulestyle[key] = appPos;
      });
      if (val.typedisplay) this.modulestyle.type = Object.assign({}, this.modulestyle.type, val.typedisplay);
      if (val.visitdom !== undefined) this.modulestyle.visit = Object.assign({}, this.modulestyle.visit, val.visitdom[0]);
      // console.log(`this.modulestyle`, this.modulestyle)
    },
    mapformHandle(val) {
      console.log(`mapformHandle`, val);
      if (!this.isMobileflag) {
        this.mapelem.bg = val.background_img && val.background_img.length > 0 ? getImg(val.background_img[0]) : '';
      }
      if (this.isMobileflag) {
        this.mapelem.bg = val.app_bg_img && val.app_bg_img.length > 0 ? getImg(val.app_bg_img[0]) : '';
      }
      this.mapelem.logo = val.logo && val.logo.length > 0 ? getImg(val.logo[0]) : '';
      this.mapelem.pickey = val.pickey && val.pickey.length > 0 ? getImg(val.pickey[0]) : '';
      if (val.bgaudioicon && val.bgaudioicon[0]) this.mapelem.bgaudio = getImg(val.bgaudioicon[0]);
      this.showtype = val.showtype;
      // this.showlistflag = val.showlistflag
      this.showlistflag = 0;
      if (val.customvisits !== undefined && val.visits !== undefined) this.visitItem[0].num = Number(val.customvisits) + Number(val.visits);
      /* centerflag 配置页调整地图center时 不触发不请求接口 */
      if (!val.centerflag) this.isHasallarea(val);
      if (val.cTemplateScore === 1) this.getCulturalFormStruct();
      /* 若包含背景音乐 */
      if (val.bgaudiofile && val.bgaudiofile[0]) this.getBgaudiofile(val.bgaudiofile[0]);
      if (val.editorList && val.editorList.length > 0) this.editorList = val.editorList;
    },
    changeMobile(val) {
      this.mapformHandle(this.form);
      if (val) {
        this.mainStyle.width = '375px';
        this.mainStyle.height = '667px';
      } else {
        this.mainStyle.width = `${window.innerWidth}px`;
        this.mainStyle.height = `${window.innerHeight}px`;
      }
    },
    markermoveend(val) {
      console.log(`val`, val);
      if (this.id === 1) {
        // 点击单个路线时 禁止缩放更新数据
        if (this.routePoint.length > 0) return;
        // 非遗模版 地点数据 无层级字段 禁止缩放获取层级数据
        if (this.form.cTemplateScore === 1) {
          // this.culturalform.page = 1
          // this.getIntangibleCulturalHeritageData()
          // if (this.isMobileflag) this.removeDrawsource()
          return;
        }
        this.popshowflag = false;
        this.removeAlliconsource();
        let zoom = val;
        let minZoom = this.mapview.minZoom;
        if (this.isMobileflag) {
          let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
          console.log(`Difference`, Difference);
          zoom += Difference;
        }
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            'alias': 'map_level',
            'compt': 'editinput',
            'express': '===',
            'val': i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.pointform.page = 1;
        this.pointList = [];
        this.getpointData();
      } else {
        this.$emit('markermoveend', val);
      }
    },
    singleclick(val) {
      this.SET_COORDINATE(val);
    },
    /**
    * 定位点击操作
    * @param {Object} feature 选中数据
    */
    markerclick(feature) {
      this.pointdetail = {};
      this.popshowflag = false;
      if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 2;
      if (feature === undefined) return;
      if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 5;
      // 判断feature类型
      let gtype = feature.getGeometry().getType();
      // point显示弹窗详情
      if (gtype === 'Point') {
        let id = feature.get('id');
        let score = feature.get('score');
        let currentInfo = '';
        if (this.pointList.length > 0) currentInfo = this.pointList.find(item => {
          return item.id === id;
        });
        if (this.mapculturalList.length > 0) currentInfo = this.mapculturalList.find(item => {
          return item.id === id;
        });
        if (currentInfo === undefined) return;
        // 标准模版获取弹窗
        if (score === 0) this.standardDetail(currentInfo);
        // 非遗模版获取弹窗
        if (score === 1) this.culturalDetail(currentInfo, feature);
      }
      // 总地图点击进入分地图
      if (gtype === 'Polygon' && this.form.ishaschild === '是' && this.id === 1) {
        let code = feature.get('code');
        let that = this;
        let mapform = {
          deptId: this.query.fid,
          formId: '177623',
          page: 1,
          limit: 100,
          searchStr: {
            model: 0,
            filters: [{
              "model": 0,
              "filters": [{
                'alias': '50',
                'compt': 'editinput',
                'express': 'like',
                'val': code
              }]
            }]
          }
        };
        mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
        this.$api.singleadvanceSearch(mapform).then(res => {
          if (res.totalRow > 0) {
            let cquery = location.hash.split('?')[1];
            let cparams = cquery.split('&');
            cparams = cparams.map(item => {
              let itemarr = item.split('=');
              if (itemarr[0] === 'formUserId') {
                itemarr[1] = res.dataList[0].id;
                item = itemarr.join('=');
              }
              return item;
            });
            window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
          }
        });
      }
      // LineString路线点击显示详情
      if (gtype === 'LineString' && feature.get('type') === 'allroute') {
        let id = feature.get('id');
        let routeItem = this.maprouteList.find(item => {
          return item.id === id;
        });
        if (routeItem !== undefined) {
          this.routePop = true;
          this.routeDetail = routeItem;
        }
      }
      if (gtype === 'Point' && feature.get('type') === 'location') {
        ElMessage({
          message: '【仅用户在地图所选区域内生效】',
          type: 'warning'
        });
      }
    },
    /**
    * 标准模版获取点位详情
    * @param {Object} feature 选中数据
    */
    standardDetail(currentInfo) {
      console.log(`标准模版获取点位详情`, currentInfo);
      let formatinfo = {};
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.audio = formatinfo.audio.length > 0 ? formatinfo.audio.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      formatinfo.video = formatinfo.video.length > 0 ? formatinfo.video.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      formatinfo.audiodesc = formatinfo.audiodesc && formatinfo.audiodesc.length > 0 ? formatinfo.audiodesc.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      formatinfo.labelGroup = this.menuList[2].menu;
      console.log(`formatinfo`, formatinfo);
      if (formatinfo['42'] === '弹窗') {
        this.pointdetail = formatinfo;
        this.popshowflag = true;
      }
      if (formatinfo['42'] === '链接' && formatinfo['44'] !== '') {
        let url = formatinfo['44'];
        if (formatinfo['44'].includes('superMapv2')) {
          let cparams = formatinfo['44'].split('?')[1];
          url = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams;
        }
        window.open(url);
      }
    },
    /**
    * 非遗模版获取点位详情
    * @param {Object} feature 选中数据
    */
    culturalDetail(currentInfo, feature) {
      console.log(`非遗模版获取点位详情`, currentInfo);
      console.log(`feature`, feature);
      console.log(`this.typeIndex`, this.typeIndex);
      let formatinfo = {};
      let coordinate = feature.xy ? feature.xy : feature.get('xy');

      // 若是非遗项目或传承人 则请求表单行接口
      if (this.typeIndex === 1 || this.typeIndex === 2) {
        let that = this;
        let formId;
        let menuindex;
        let formUserId = currentInfo.id || feature.get('id');
        if (this.typeIndex === 1) {
          formId = 'cultural_heritage_project';
          menuindex = 0;
        }
        if (this.typeIndex === 2) {
          formId = 'cultural_heritage_inheritor';
          menuindex = 1;
        }
        this.$api.singleformUserId(this.query.fid, formId, formUserId).then(res => {
          if (res.formUserList.length > 0) {
            res.formUserList[0].formData.forEach(item => {
              formatinfo[item.alias] = getformitemsdata(item);
            });
            formatinfo.id = currentInfo.id;
            formatinfo.coordinate = coordinate;
            if (formatinfo.detailUrl !== undefined && formatinfo.detailUrl !== '') {
              formatinfo.gateway = `${formatinfo.detailUrl}${formatinfo.detailUrl.includes('?') ? '&' : '?'}mapid=${formatinfo.number}`;
            }
            formatinfo.pixelcoordinate = that.$refs.mapv2assembly.getmapPixelFromCoordinate(currentInfo);
            formatinfo.labelGroup = that.menuList[menuindex].menu;
            that.pointdetail = formatinfo;
            that.popshowflag = true;
            that.typeUlzIndex = true;
            console.log(`formatinfo`, formatinfo);
            formatinfo.formId = currentInfo.formId;
            this.updateViews(formatinfo);
          }
        });
        return;
      }
      this.updateViews(currentInfo);
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      if (formatinfo.clink !== undefined && formatinfo.clink !== '') {
        window.open(formatinfo[formatinfo.clink]);
        return;
      }
      formatinfo.id = currentInfo.id;
      formatinfo.coordinate = coordinate;
      if (formatinfo.detailUrl !== undefined && formatinfo.detailUrl !== '') {
        formatinfo.gateway = `${formatinfo.detailUrl}${formatinfo.detailUrl.includes('?') ? '&' : '?'}mapid=${formatinfo.number}`;
      }
      formatinfo.pixelcoordinate = this.$refs.mapv2assembly.getmapPixelFromCoordinate(currentInfo);
      this.pointdetail = formatinfo;
      this.popshowflag = true;
      this.typeUlzIndex = true;
      console.log(`this.pointdetail`, this.pointdetail);
      console.log(`this.popshowflag`, this.popshowflag);
    },
    /**
    * 弹窗关闭事件
    */
    closeHandle() {
      this.popshowflag = false;
      this.pointdetail = {};
      if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 2;
      this.typeUlzIndex = false;
    },
    /**
    * 分类选择事件
    */
    typeselect(val) {
      if (this.id === 1) {
        this.typeClick(val);
      } else {
        this.$emit('typeselect', val);
      }
    },
    /**
     * 分类数据格式化
     */
    typebtnFormat(val) {
      let typebtn = [...val];
      this.typebtn = [];
      typebtn.forEach(elem => {
        let item = {
          ...elem
        };
        if (item.imgList && item.imgList.length > 0) {
          item.backgroundImage = 'url(\'' + getImg(item.imgList[0]) + '\')';
          item.backgroundSize = '100% 100%';
          item.backgroundRepeat = 'no-repeat';
        }
        item.textAlign = 'center';
        delete item.imgList;
        let newitem = {};
        Object.keys(item).forEach(child => {
          if (this.isMobileflag) {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 2 / 37.5).toFixed(6))}rem` : item[child];
          } else {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 1920 * 100).toFixed(6))}vw` : item[child];
          }
        });
        this.typebtn.push(newitem);
      });
    },
    removeAlliconsource() {
      this.$refs.mapv2assembly.removeAlliconsource();
    },
    saveDrawHandle() {
      this.$refs.mapv2assembly.saveDrawHandle();
    },
    updateMap() {
      this.$refs.mapv2assembly.updateMap();
    },
    removeDrawsource() {
      this.$refs.mapv2assembly.removeDrawsource();
    },
    removeRoutesource() {
      this.$refs.mapv2assembly.removeRoutesource();
    },
    isHasallarea(val) {
      let that = this;
      let mapform = {
        deptId: this.query.fid,
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: {
          model: 0,
          filters: [{
            "model": 0,
            "filters": [{
              'alias': 'ishaschild',
              'compt': 'radiobutton',
              'express': '===',
              'val': ['是']
            }]
          }]
        }
      };
      mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
      this.$api.singleadvanceSearch(mapform).then(res => {
        if (res.totalRow > 0) {
          this.showgolist = val.ishaschild === '是' ? false : true;
          if (this.showgolist) this.showgolistId = res.dataList[0].id;
        }
      });
    },
    golist() {
      let cquery = location.hash.split('?')[1];
      let cparams = cquery.split('&');
      cparams = cparams.map(item => {
        let itemarr = item.split('=');
        if (itemarr[0] === 'formUserId') {
          itemarr[1] = this.showgolistId;
          item = itemarr.join('=');
        }
        return item;
      });
      window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
    },
    /**
     * 获取非遗项目表单结构数据
     */
    getCulturalFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 'cultural_heritage_project'
      };
      this.$api.formStruct(params).then(res => {
        this.cstructList = JSON.parse(JSON.stringify(res));
        this.cpList = getformatstruct(res, this.cform, this.cformlabel, this.cformfield, this.cformoption);
        this.defaultcform = Object.assign({}, this.cform);
        console.log(`this.cformoption`, this.cformoption);
        this.getHeritageLevel();
      });
    },
    setComonStyle() {
      document.querySelector('html').style.fontSize = `${window.screen.width / 10}px`;
    },
    /**
     * 获取非遗级别数据
     */
    getHeritageLevel() {
      let that = this;
      const levelform = {
        formId: 'cultural_heritage_level',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c6214264990ae6ee87a7ea8354f1ddd10d27fc0b22c007dd5f32f533e2812ebe6a5db5'
      };
      levelform.deptId = this.query.fid;
      this.$api.singleadvanceSearchv2(levelform).then(res => {
        if (res.totalRow > 0) {
          let dataList = that.formdataformat(res);
          that.cformoption.level = dataList.map(item => {
            return {
              title: item.itemformdata.title,
              order: item.itemformdata.order
            };
          });
        }
      });
    },
    /**
     * 获取地图设置行
     */
    getMapData() {
      let that = this;
      this.$api.singleformUserId(this.query.fid, '177623', this.query.formUserId).then(res => {
        if (res.formUserList.length > 0) {
          that.cformUser = res.formUserList[0];
          let formatData = {};
          res.formUserList[0].formData.forEach(item => {
            formatData[item.alias] = getformitemsdata(item);
          });
          that.formatData = formatData;
          document.title = formatData.toptitle;
          // 处理地图view相关字段
          that.getFormStruct();
        }
      });
    },
    /**
     * 获取地图配置表单结构
     */
    getFormStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        this.sList = getformatstruct(res, this.form, this.formlabel, this.formfield, this.formoption);
        this.mapview = this.mapv2info.view;
        this.editlogic(this.formatData);
        // this.gettypeList()

        this.pointform.deptId = this.query.fid;
        this.getpointData();

        // this.menuData = this.flattenMenuList(this.menuList)
        this.initialProcessMenuList(this.menuList, [0]).then(() => console.log('所有菜单项处理完成')).catch(err => console.error('处理 menuList 时出错:', err));
      });
    },
    /**
     * 配置页编辑逻辑处理
     */
    editlogic(data) {
      let that = this;
      this.mapLayers.tiles = true;
      this.mapLayers.json = true;
      this.mapLayers.static = false;
      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      this.jsonOption = {
        ...JSON.parse(this.form.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
      };
      if (this.jsonOption.screen && Object.keys(this.jsonOption.screen).length > 0) {
        let screenData = this.isMobileflag ? this.jsonOption.screen.app : this.jsonOption.screen.pc;
        Object.keys(screenData).forEach(item => {
          this.jsonOption[item] = screenData[item];
        });
      }
      console.log(`this.jsonOption`, this.jsonOption);
      this.mapviewhandle(this.jsonOption.view);
      this.form.showtype = this.jsonOption.style.showtype;
      this.form.showlistflag = this.jsonOption.style.showlistflag;
      this.form.scale = this.jsonOption.view.scale;
      this.form.rotate = this.jsonOption.view.rotate;
      this.form.typeall = this.jsonOption.style.typeall !== undefined ? this.jsonOption.style.typeall : true;
      this.form.typeallname = this.jsonOption.style.typeallname ? this.jsonOption.style.typeallname : '全部';
      this.form.routelinetype = this.jsonOption.style.routelinetype ? this.jsonOption.style.routelinetype : 1;
      if (this.form.fillcolor) this.form.fillcolor = [...JSON.parse(this.form.fillcolor.replace(/(<\/?p.*?>)/gi, ''))];
      this.form.fillimageindex = this.form.fillimageindex && this.form.fillimageindex !== '' ? Number(this.form.fillimageindex) : this.form.fillimageindex === '' ? this.form.fillimageindex : 1;
      if (this.form.static_img && this.form.static_img.length > 0) this.mapLayers.staticimage = getImg(this.form.static_img[0]);
      if (this.form.mapmodetype === this.formoption.mapmodetype[1].title && this.form.filltype === this.formoption.filltype[1].title && this.form.fillclipimage !== '') {
        this.form.fillclipimage = this.form.fillclipimage.replace(/(<\/?p.*?>)/gi, '').match(/src="([^"]*)"/i)[1];
        this.mapLayers.staticimage = this.form.fillclipimage;
      }
      if (this.form.background_img && this.form.background_img.length > 0) this.mapLayers.tiles = false;
      if (this.mapLayers.staticimage !== '') this.mapLayers.static = true;
      this.SET_MAPFORM(this.form);
      this.SET_MAPVIEW(this.jsonOption.view);
      this.SET_MAPSENIOR(this.jsonOption.senior);
      this.SET_MAPSTYLEITEM({
        showtype: this.jsonOption.style.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlistflag: this.jsonOption.style.showlistflag
      });
      this.SET_MAPSTYLEITEM({
        typeall: this.form.typeall
      });
      this.SET_MAPSTYLEITEM({
        typeallname: this.form.typeallname
      });
      this.SET_MAPSTYLEITEM({
        routelinetype: this.form.routelinetype
      });
      this.mapview = this.jsonOption.view;
      this.mapstyle = this.jsonOption.style;
      this.mapstyle.typeall = this.form.typeall;
      this.mapstyle.typeallname = this.form.typeallname;
      this.mapstyle.pointStyleIndex = 5;
      this.mapstyle.pointtext.fill = '#852E2D';
      this.mapstyle.pointtext.color = '#ffffff';
      console.log(`this.mapstyle`, this.mapstyle);
      this.mapsenior = this.jsonOption.senior;

      // 若开启浏览量 增加浏览量
      if (this.mapsenior.visit) this.getVisits();

      // 判断当前地图模版 score  0标准模版  1非遗模版
      this.formoption.mapTemplate.forEach(elem => {
        if (this.formatData.mapTemplate === elem.title) {
          this.cTemplateScore = elem.score;
          this.SET_MAPFORMITEM({
            cTemplateScore: elem.score
          });
        }
      });
      this.SET_MAPDRAWLAYER(this.jsonOption.drawlayer);
      this.mapLayers.drawelement = this.jsonOption.drawlayer;
      if (this.form.componentjson !== undefined) {
        let comptdata = this.form.componentjson.replace(/(<\/?p.*?>)/gi, '');
        if (comptdata !== '') {
          let data = JSON.parse(comptdata);
          this.form.editorList = this.isMobileflag ? data.appList : data.List;
        }
      }
      this.mapformHandle(this.form);
      this.$nextTick(() => {
        // console.log(`this.jsonOption.style`, this.jsonOption.style)
        this.styleHandle(this.jsonOption.style);
        this.typebtnFormat(this.jsonOption.style.typebtn);
        this.popcolorFormat(this.jsonOption.style.popcolor);
      });
      // 是否含有乡镇街道
      if (Object.prototype.toString.call(this.jsonOption.geojson) === '[object Array]' && this.jsonOption.geojson[0].code) {
        this.mapstreetcode = this.jsonOption.geojson.map(item => {
          return item.code;
        });
      } else if (Object.prototype.toString.call(this.jsonOption.geojson) === '[object Object]' && this.jsonOption.geojson.code) {
        this.mapstreetcode = [this.jsonOption.geojson.code];
      }
      let adcode = this.jsonOption.view.adcode;
      if (this.mapstreetcode.length > 0) {
        axios.get(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/${adcode}.json`).then(res => {
          if (res.status === 200) {
            let jsondata = res.data;
            let filterJson = [];
            that.mapstreetcode.forEach(street => {
              jsondata.features.forEach(feature => {
                if (Number(feature.properties.code) === Number(street)) filterJson.push(feature);
              });
            });
            jsondata.features = filterJson;
            that.mapLayers.geojson = jsondata;
            that.loadingmap = true;
          }
        }).catch(error => {});
        return;
      }
      // 自定义json数据
      if (this.jsonOption.view.adcode === 'region') {
        let datacoord = this.jsonOption.geojson.features[0].geometry.coordinates[0];
        let changedata = [];
        datacoord.forEach(elem => {
          changedata.push(transform(elem, 'EPSG:4326', 'EPSG:3857'));
        });
        this.jsonOption.geojson.features[0].geometry.coordinates[0] = changedata;
        this.mapLayers.geojson = {
          type: 'FeatureCollection',
          features: this.jsonOption.geojson.features
        };
      }
      this.loadingmap = true;
    },
    mapviewhandle(view) {
      let center = view.center;
      this.form.centerX = center[0];
      this.form.centerY = center[1];
      this.form.minZoom = view.minZoom;
      this.form.maxZoom = view.maxZoom;
      this.form.zoom = view.zoom;
      this.form.static_map_min_level = view.minZoom;
      this.form.static_map_max_level = view.maxZoom;
      this.form.current_level = view.zoom;
      this.form.map_center = center.join(',');
      this.form.transform_extent = view.extent.join(',');
    },
    /**
     * 获取地点管理表数据
     */
    getpointData(val) {
      let that = this;
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.defaultpointList = [];
          let dataList = that.formdataformat(res);
          that.defaultpointList = that.pointform.page === 1 ? dataList : that.defaultpointList.concat(dataList);
          if (res.totalPage > 1) that.pointform.page++;
          if (res.totalPage === 1 || res.totalPage > 1 && res.totalPage + 1 === that.pointform.page) {
            that.pointList = that.defaultpointList.filter(item => {
              return item.itemformdata[42] === '仅展示' && item.itemformdata.map_type2 !== '游学路线';
            });
          }
          if ((res.totalPage === 1 || res.totalPage === that.pointform.page) && val === undefined) that.getroutetypeData();
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getpointData();
        }
      });
    },
    /**
     * 点击类型操作
     * @param {Object} data 选中数据及索引 index item
     */
    typeClick(data) {
      this.cType = data;
      this.popshowflag = false;
      this.removeAlliconsource();
      let dindex = data.index;
      let val = dindex === 0 ? '' : !data.child ? data.item.itemformdata : data.child;
      let typesearchflag = false;
      if (dindex === 0) {
        this.searchStr.filters.forEach((item, index) => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') this.searchStr.filters.splice(index, 1);
        });
      } else {
        this.searchStr.filters.forEach(item => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') {
            item.filters[0].val = val.title;
            typesearchflag = true;
          }
        });
        if (!typesearchflag) {
          this.searchStr.filters.push({
            "model": 0,
            "filters": [{
              'alias': 'map_type2',
              'compt': 'editinput',
              'express': 'like',
              'val': val.title
            }]
          });
        }
      }
      let zoom = this.mapview.zoom;
      let minZoom = this.mapview.minZoom;
      if (this.isMobileflag) {
        let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
        console.log(`Difference`, Difference);
        zoom += Difference;
      }
      let orData = [];
      for (let i = minZoom; i <= zoom; i++) {
        orData.push({
          'alias': 'map_level',
          'compt': 'editinput',
          'express': '===',
          'val': i
        });
      }
      this.searchStr.filters.forEach(item => {
        if (item.filters.length > 0 && item.filters[0].alias === '40' && item.filters[0].val === '') item.filters[0].val = this.form.title;
        if (item.model === 1) item.filters = orData;
      });
      if (this.pointform.deptId === undefined) this.pointform.deptId = this.query.fid;
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      this.getpointData();
      // 点击非全部类型 隐藏路线列表
      this.$refs.routelist.routebtnHide();
      this.$refs.mapv2assembly.removeRoutesource();
    },
    pointlistClick(item) {
      let components = this.$refs.pointlist.$options.components;
      Object.keys(components).forEach(key => {
        if (this.mapstyle.listStyleIndex === Number(key.charAt(key.length - 1))) components[key].methods.listDown();
      });
      this.pointdetail = {};
      this.popshowflag = false;
      let citem = item.itemformdata;
      if (this.cTemplateScore === 0) this.standardDetail(item);
      if (this.cTemplateScore === 1 && citem.correlation_address.length > 0) {
        let gd = bd_decrypt(Number(citem.correlation_address[0].lng), Number(citem.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        this.culturalDetail(item, {
          xy: [x, y]
        });
      }
    },
    listUp(val) {
      this.pointdetail = {};
      this.popshowflag = false;
      this.typeUlzIndex = val;
      if (this.isMobileflag && !val) this.showlistflag = 0;
    },
    formdataformat(res) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        return item;
      });
    },
    getroutetypeData() {
      let that = this;
      this.rtypeform.deptId = this.query.fid;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'mapbelongId',
            'compt': 'editinput',
            'express': '===',
            'val': this.formatData.onlyid
          }]
        }]
      };
      this.rtypeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.rtypeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.rtypeform.page === 1) that.rtypeList = [];
          let dataList = that.formdataformat(res);
          let sortdataList = dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          that.rtypeList = that.routeform.page === 1 ? sortdataList : that.rtypeList.concat(sortdataList);
          if (res.totalPage > 1) that.rtypeform.page++;
          if (res.totalPage === 1 || res.totalPage === that.rtypeform.page) that.getrouteData();
          if (res.totalPage > 1 && res.totalPage >= that.rtypeform.page) that.getroutetypeData();
        }
      });
    },
    /**
     * 获取路线管理表表单数据
     */
    getrouteData() {
      let that = this;
      this.routeform.deptId = this.query.fid;
      this.$api.singleadvanceSearchv2(this.routeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.routeform.page === 1) that.maprouteList = [];
          let dataList = that.formdataformat(res);
          that.maprouteList = that.routeform.page === 1 ? dataList : that.maprouteList.concat(dataList);
          if (res.totalPage > 1) that.routeform.page++;
          // if (res.totalPage === 1 || res.totalPage === that.routeform.page) {
          //     if (that.cType === '') that.routeHandle(that.maprouteList)
          // }
          if (res.totalPage > 1 && res.totalPage >= that.routeform.page) that.getrouteData();
        }
      });
    },
    routeChange(val) {
      console.log(`routeChange`, val);
      if (val.length === 0) {
        this.closeRouteMenu();
        return;
      }
      this.mapLayers.route = true;
      this.getsingleroute(val);
    },
    getsingleroute(val) {
      let routePoint = [];
      val.forEach(elem => {
        this.routejson = {
          ...JSON.parse(elem.itemformdata.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
        };
        this.routejson.routedata.forEach(item => {
          let route = this.pointList.find(point => {
            return point.id === item.id;
          });
          if (route !== undefined) routePoint.push(route);
        });
      });
      this.routePoint = routePoint;
      this.setRoutePoint(routePoint);
      this.routeHandle(val);
    },
    routeHandle(val) {
      this.routeAllLen = val.length;
      this.routeAllSource = [];
      let routes = [];
      for (let i = 0; i < this.routePoint.length - 1; i++) {
        let start = this.routePoint[i].itemformdata.map_coordinates.split(',').map(parseFloat);
        let end = this.routePoint[i + 1].itemformdata.map_coordinates.split(',').map(parseFloat);
        routes.push([start, end]);
      }

      // 若存在curvedata参数 代表曲线
      if (this.routejson.curvedata !== undefined && this.form.routelinetype === 3 && this.routejson.curvedata.length > 0) {
        routes.forEach((item, index) => {
          let curveitem = this.routejson.curvedata[index];
          if (curveitem !== null) curveitem.forEach((point, pIndex) => {
            item.splice(pIndex + 1, 0, [point[0], point[1]]);
          });
        });
      }
      if (routes.length === 0) {
        this.routeAllSource = [];
        this.SET_MAPROUTESOURCE([]);
        return;
      }
      if (this.form.routelinetype === 1) {
        this.routeAllSource = [];
        let routeItemAllpath = [];
        this.routeDriving(routes, 0, routeItemAllpath, this.routejson.style, val[0].id);
      }
      if (this.form.routelinetype !== 1) {
        let paths = routes.map(elem => {
          return elem.map(item => {
            return transform([item[0], item[1]], 'EPSG:4326', 'EPSG:3857');
          });
        });
        console.log(`paths`, paths);
        this.SET_MAPROUTESOURCE([{
          path: paths,
          style: this.routejson.style,
          routelinetype: this.form.routelinetype,
          isCurve: false
        }]);
      }
    },
    routeDriving(routes, index, routeItemAllpath, linestyle, id) {
      let route = routes[index];
      if (route === undefined) return;
      let start = new window.BMapGL.Point(route[0][0], route[0][1]);
      let end = new window.BMapGL.Point(route[1][0], route[1][1]);
      let driving = new window.BMapGL.DrivingRoute(this.mapcontainer);
      driving.search(start, end);
      driving.setSearchCompleteCallback(() => {
        let routepath = [];
        if (driving.getResults() === undefined) return;
        let pots = driving.getResults().getPlan(0).getRoute(0).getPath();
        pots.forEach((pot, idx) => {
          let bdTogd = bd_decrypt(pot.lng, pot.lat);
          routepath.push(transform([bdTogd.lng, bdTogd.lat], 'EPSG:4326', 'EPSG:3857'));
        });
        routeItemAllpath.push(routepath);
        if (routes.length === 1 || index === routes.length - 1) {
          this.routeAllSource.push({
            path: routeItemAllpath,
            style: linestyle,
            id: id
          });
          this.SET_MAPROUTESOURCE(this.routeAllSource);
          // if (this.routeAllSource.length === this.routeAllLen) this.SET_MAPROUTESOURCE(this.routeAllSource)
        }
        if (routes.length > 1 && index <= routes.length - 1) this.routeDriving(routes, index + 1, routeItemAllpath, linestyle, id);
      });
    },
    routeshow(val) {
      this.mapLayers.route = val;
    },
    /**
     * 增加浏览量
     */
    getVisits() {
      let that = this;
      let nowTime = new Date();
      let date = formateDate(nowTime, 'yyyy-MM-dd');
      const searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'id',
            'compt': 'editinput',
            'express': '===',
            'val': this.formatData.onlyid
          }, {
            'alias': 'date',
            'compt': 'editinput',
            'express': '===',
            'val': date
          }]
        }]
      };
      this.visitform.deptId = this.query.fid;
      this.visitform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.visitform).then(res => {
        res.totalRow > 0 ? that.editVisit(res, nowTime) : that.addVisit(nowTime, date);
      });
    },
    addVisit(nowTime, date) {
      let dataList = [];
      dataList.push({
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': ''
        }]
      });
      dataList.push({
        'alias': 'title',
        'compt': 'selectbox',
        'values': [{
          'val': this.formatData.title
        }]
      });
      dataList.push({
        'alias': 'id',
        'compt': 'editinput',
        'values': [{
          'val': this.formatData.onlyid
        }]
      });
      dataList.push({
        'alias': 'date',
        'compt': 'editinput',
        'values': [{
          'val': date
        }]
      });
      dataList.push({
        'alias': 'timestamp',
        'compt': 'editinput',
        'values': [{
          'val': nowTime.getTime()
        }]
      });
      dataList.push({
        'alias': 'visits',
        'compt': 'numberinput',
        'values': [{
          'val': 1
        }]
      });
      console.log(`dataList`, dataList);
      let formData = {
        deptId: this.query.fid,
        formId: this.visitform.formId,
        uid: this.query.uid
      };
      this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {});
    },
    editVisit(res, nowTime) {
      let resList = this.formdataformat(res);
      let dataList = [];
      dataList.push({
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': resList[0].itemformdata.onlyid
        }]
      });
      dataList.push({
        'alias': 'title',
        'compt': 'selectbox',
        'values': [{
          'val': this.formatData.title
        }]
      });
      dataList.push({
        'alias': 'visits',
        'compt': 'numberinput',
        'values': [{
          'val': Number(resList[0].itemformdata.visits) + 1
        }]
      });
      dataList.push({
        'alias': 'timestamp',
        'compt': 'editinput',
        'values': [{
          'val': nowTime.getTime()
        }]
      });
      this.$api.editForm(this.query.fid, resList[0].id, encodeURI(JSON.stringify(dataList)), resList[0].formId).then(res => {});
    },
    setRoutePoint(val) {
      this.$refs.mapv2assembly.removeAlliconsource();
      this.$refs.mapv2assembly.removeRoutesource();
      this.$refs.mapv2assembly.createPoint(val);
      // this.$refs.mapv2assembly.stopMove(true)
    },
    /**
     * 添加特效
     */
    effectAnimate() {
      this.$nextTick(() => {
        document.querySelector('.yunbox').classList.remove('hidden');
        const yunl = document.querySelector('.yunl');
        const yunr = document.querySelector('.yunr');
        let keyframesl = [{
          left: '-100%'
        }];
        let keyframesr = [{
          right: '-100%'
        }];
        let options = {
          duration: 4000,
          iterations: 1,
          fill: 'forwards'
        };
        yunl.animate(keyframesl, options).onfinish = () => {
          const yunbox = document.querySelector('.yunbox');
          if (yunbox !== null) yunbox.classList.add('hidden');
        };
        yunr.animate(keyframesr, options).onfinish = () => {};
      });
    },
    /**
     * 背景音乐操作事件
     */
    bgaudioHandle() {
      this.bgaudioflag = !this.bgaudioflag;
      if (this.form.bgaudioicon) {
        this.mapelem.bgaudio = !this.bgaudioflag ? this.form.bgaudioicon[1] ? getImg(this.form.bgaudioicon[1]) : '' : this.form.bgaudioicon[0] ? getImg(this.form.bgaudioicon[0]) : '';
      }
      if (this.form.bgaudiofile && this.form.bgaudiofile[0]) {
        !this.bgaudioflag ? this.$refs.bgaudio.pause() : this.$refs.bgaudio.play();
      }
    },
    /**
     * 获取背景音乐文件
     */
    getBgaudiofile(val) {
      this.$api.getUrlByObjectId(val.objectid || val.objectId).then(res => {
        this.bgaudio = res.http;
      });
    },
    domChange(item) {
      /* 展示页不需要编辑dom样式 */
      if (this.id === 1) {
        console.log(item);
        if (Object.keys(item.data).length === 0) return;
        if (item.data.url !== '') item.data.way ? window.open(item.data.url) : window.location.href = item.data.url;
        return;
      }
      console.log(item);
      this.$emit('domclick', item);
    },
    getdomStyle(val) {
      let data = {
        ...val
      };
      data.width = Math.round(data.width * (data.scaleX ? data.scaleX : 1)) + 'px';
      data.height = Math.round(data.height * (data.scaleY ? data.scaleY : 1)) + 'px';
      data.left = Math.round(data.x) + 'px';
      data.top = Math.round(data.y) + 'px';
      return data;
    },
    /**
     * 按menulist依次请求数据
     * @date 2025-03-06
     */
    async fetchData(menuItem) {
      const {
        formId,
        page,
        limit,
        searchStr,
        t,
        icon
      } = menuItem;
      let allData = []; // 存储所有分页数据
      let currentPage = page || 1; // 当前页码，默认为 1
      let hasMore = true; // 是否还有更多数据
      let totalPage = 1;
      while (hasMore) {
        try {
          // 构造请求参数
          const params = {
            formId,
            page: currentPage,
            limit,
            searchStr: encodeURI(JSON.stringify(this.menusearchStr)),
            t,
            deptId: this.query.fid
          };
          if (currentPage > totalPage) return allData;
          // 发送请求
          let response;
          if (formId === 'cultural_heritage_project' || formId === 'cultural_heritage_inheritor') {
            const cdomain = `${process.env.NODE_ENV == 'development' ? '/all' : 'https://all.chaoxing.com'}`;
            response = await this.$api.getCulturalHeritage(cdomain, params);
          } else {
            response = await this.$api.singleadvanceSearchv2(params);
          }
          totalPage = response.totalPage;
          // 将当前页的数据添加到 allData
          if (response.totalPage && response.totalPage >= currentPage) {
            const dataList = this.menudataformformat(response, menuItem);
            allData = allData.concat(dataList);
            currentPage++; // 页码加 1
          } else {
            hasMore = false; // 没有更多数据，退出循环
          }
        } catch (error) {
          console.error(`请求失败: ${menuItem.name}`, error);
          hasMore = false; // 出错时退出循环
        }
      }
      return allData;
    },
    async gobackfetchData(item) {
      const data = await this.fetchData(item);
      this.allMenuList.push({
        id: item.id,
        name: item.name,
        formId: item.formId,
        editAlias: item.editAlias,
        editFormId: item.editFormId,
        data: data
      });
      // if (this.oncehidewhkjFlag && item.id === 6) return
      if (data.length > 0) this.mapculturalList.push(...data);
    },
    /**
     * 初始处理 menuList 的函数
     * @date 2025-03-06
     * @updatedate 2025-03-20
     */
    async initialProcessMenuList(menuData, defaultLoadArr) {
      this.allMenuList = [];
      this.mapculturalList = [];
      for (const item of defaultLoadArr) {
        const menuItem = menuData[item];
        // 如果菜单项有 formId，说明需要请求接口
        if (menuItem.formId) await this.gobackfetchData(menuItem);
      }
      this.mapculturalList = this.mapculturalList.filter(item => {
        return item.formId !== 1938372;
      });
      this.defaultmapculturalList = this.mapculturalList;
      // this.oncehidewhkjFlag = false
      // 获取文化空间数据
      const culturalspace = await this.$api.singleadvanceSearchv2({
        deptId: this.query.fid,
        formId: this.menuList[5].formId,
        page: 1,
        limit: 100,
        searchStr: '',
        onlyReturnCount: 1,
        t: this.menuList[5].t
      });
      this.whkjsumtotal = culturalspace.totalRow;
      // 获取文化活动数据量
      const statresponse = await this.getGatewayactivitystat();
      this.whhdSum = statresponse.data.data.activityNum;
      // 获取文化设施数据量
      const facilitiesresponse = await this.$api.singleadvanceSearchv2({
        deptId: this.query.fid,
        formId: '1990574',
        page: 1,
        limit: 100,
        searchStr: '',
        t: 'ccd548e74f093ac2f4b8141854cfad6a6734102c52770ead09fa755f4d7e341b'
      });
      if (facilitiesresponse.totalRow > 0) {
        this.whssSum = 0;
        const dataList = this.formdataformat(facilitiesresponse);
        dataList.forEach(item => {
          this.whssSum += Number(item.itemformdata[4]);
        });
      }
      this.allLoading = false;
      this.rollNumber();
    },
    menudataformformat(res, menuItem) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        if (itemformat.title === undefined) itemformat.title = itemformat.name || itemformat.venueName;
        itemformat.icon = menuItem.icon;
        itemformat.unique = menuItem.formId;
        itemformat.labelGroup = menuItem.menu;
        itemformat.clink = menuItem.clink;
        item.itemformdata = itemformat;
        return item;
      });
    },
    flattenMenuList(menuList) {
      const result = []; // 存储扁平化后的菜单项
      // 递归处理菜单项
      function processMenuItem(item) {
        if (item.children) {
          // 如果有 children，递归处理每个子项
          item.children.forEach(child => processMenuItem(child));
        } else {
          // 如果没有 children，直接添加到结果中
          result.push(item);
        }
      }
      // 遍历 menuList，处理每个菜单项
      menuList.forEach(item => processMenuItem(item));
      return result;
    },
    /**
     * 点击菜单事件
     * @date 2025-03-10
     */
    async typeUlswtich(index, elem, type, child) {
      this.$refs.pointlist.loading = true;
      this.recordType = {
        index: index,
        elem: elem,
        type: type,
        child: child
      };
      // console.log(`this.recordType`, this.recordType)
      this.$refs.mapv2assembly.removeAlliconsource();
      this.mapculturalList = [];
      this.listFlag = true;
      if (type === undefined) {
        this.typeIndex = index;
        this.typechildIndex = '';
      } else {
        this.typechildIndex = index;
      }
      if (elem.id === 3) {
        // 游学路线
        this.listFlag = false;
        this.pointList = this.defaultpointList.filter(item => {
          return item.itemformdata[42] === '仅展示' || item.itemformdata.map_type2 === '游学路线';
        });
        this.$refs.routelist.routebtnHandle();
        return;
      } else if (elem.id === 7 && child === undefined) {
        // 物质文化遗产 请求可移动、不可移动文物
        let menuitem = this.allMenuList.filter(item => {
          return item.id === 71 || item.id === 72;
        });
        let relmenu = this.menuList.find(item => {
          return item.id === 7;
        });
        if (menuitem.length === 0) {
          for (const child of relmenu.children) {
            this.gobackfetchData(child);
          }
        } else {
          menuitem.forEach(item => this.mapculturalList.push(...item.data));
        }
        this.defaultmapculturalList = this.mapculturalList;
      } else if (child !== undefined && (child.id === 71 || child.id === 72)) {
        // 请求可移动、不可移动文物
        let menuitem = this.allMenuList.filter(item => {
          return item.id === child.id;
        });
        this.mapculturalList = [...menuitem[0].data];
        this.defaultmapculturalList = this.mapculturalList;
      } else {
        if (type === 1) {
          this.mapculturalList = this.defaultmapculturalList.filter(item => {
            return item.itemformdata[elem.compt] === child;
          });
          this.pointList = this.defaultpointList.filter(item => {
            return item.itemformdata[42] === '仅展示' && item.itemformdata.map_type2 !== '游学路线';
          });
          return;
        }
        let menuitem = this.allMenuList.filter(item => {
          return item.id === elem.id;
        });
        let relmenu = this.menuList.find(item => {
          return item.id === elem.id;
        });
        if (menuitem.length === 0) {
          await this.gobackfetchData(relmenu);
        } else {
          this.mapculturalList.push(...menuitem[0].data);
        }
        this.defaultmapculturalList = this.mapculturalList;
      }
      if (elem.id !== 3) {
        this.$refs.routelist.routebtnHide();
        this.$refs.mapv2assembly.removeRoutesource();
      }
      this.pointList = this.defaultpointList.filter(item => {
        return item.itemformdata[42] === '仅展示' && item.itemformdata.map_type2 !== '游学路线';
      });
    },
    /**
     * 获取活动市场的
     * @date 2025-03-10
     */
    getGatewayactivitystat() {
      return axios({
        url: `${process.env.NODE_ENV == 'development' ? '/all' : 'https://all.chaoxing.com'}/api/v1/cultural_heritage/activity-stat?marketId=20374`,
        method: 'get'
      });
    },
    /**
     * 处理 数字上下滚动 效果
     * @date 2025-03-17
     */
    rollNumber() {
      console.log(`this.allMenuList`, this.allMenuList);
      let that = this;
      // let whkjsum = this.allMenuList.filter(item => { return item.id === 6 })[0].data
      this.whkjSum = this.whkjsumtotal.toString().split('').map(item => {
        return {
          rel: item,
          val: this.isMobileflag ? item : 0
        };
      });
      this.whhdSum = this.whhdSum.toString().split('').map(item => {
        return {
          rel: item,
          val: this.isMobileflag ? item : 0
        };
      });
      this.whssSum = this.whssSum.toString().split('').map(item => {
        return {
          rel: item,
          val: this.isMobileflag ? item : 0
        };
      });
      if (!this.isMobileflag) {
        let whkjnum = 0;
        this.whkjTimer = setInterval(() => {
          if (whkjnum >= that.whkjSum.length) {
            clearInterval(that.whkjTimer);
          } else {
            that.whkjSum[whkjnum].val = Number(that.whkjSum[whkjnum].rel);
            whkjnum++;
          }
        }, 500);
        let whhdnum = 0;
        this.whhdTimer = setInterval(() => {
          if (whhdnum >= that.whhdSum.length) {
            clearInterval(that.whhdTimer);
          } else {
            that.whhdSum[whhdnum].val = Number(that.whhdSum[whhdnum].rel);
            whhdnum++;
          }
        }, 500);
        let whssnum = 0;
        this.whssTimer = setInterval(() => {
          if (whssnum >= that.whssSum.length) {
            clearInterval(that.whssTimer);
          } else {
            that.whssSum[whssnum].val = Number(that.whssSum[whssnum].rel);
            whssnum++;
          }
        }, 500);
      }
    },
    showcontrolList() {
      this.showlistflag = this.showlistflag === 0 ? 1 : 0;
      console.log(`this.showlistflag`, this.showlistflag);
      if (this.isMobileflag) this.$refs.pointlist.listUp();
    },
    closeRouteMenu() {
      this.pointList = this.defaultpointList.filter(item => {
        return item.itemformdata[42] === '仅展示' || item.itemformdata.map_type2 === '游学路线';
      });
      // this.typeUlswtich(1, this.menuList[0])
      // this.typeClick(this.cType === '' ? { index: 0, item: '' } : this.cType)
      // 点击非全部类型 隐藏路线列表
      this.$refs.routelist.routebtnHide();
      this.$refs.mapv2assembly.removeRoutesource();
    },
    /**
     * 编辑表单浏览量
     * @param {Object} data 点位数据
     * @date 2025-06-20
     */
    updateViews(data) {
      let dataList = [];
      const comptrules = [{
        compt: 'editinput',
        alias: 'title,name,venueName'
      }, {
        compt: 'autonumber',
        alias: 'number,1,identifier'
      }];
      let newViews = 0;
      let itemAlias = [];
      this.allMenuList.forEach(item => {
        if (item.editFormId === data.formId) {
          item.data.forEach(child => {
            if (child.id === data.id) {
              let views;
              if (child.itemformdata.views === undefined) {
                console.log(`data`, data);
                views = data.views !== '' ? Number(data.views) : 0;
                newViews = views + 1;
                child.itemformdata.views = newViews;
              } else {
                views = child.itemformdata.views !== '' ? Number(child.itemformdata.views) : 0;
                newViews = views + 1;
                child.itemformdata.views = newViews;
              }
            }
          });
          itemAlias = item.editAlias;
        }
      });
      itemAlias.forEach(item => {
        let compt;
        comptrules.forEach(c => {
          if (c.alias.includes(item)) compt = c.compt;
        });
        dataList.push({
          alias: item,
          compt: compt,
          values: [{
            'val': data.itemformdata !== undefined ? data.itemformdata[item] : data[item]
          }]
        });
      });
      dataList.push({
        alias: 'views',
        compt: 'numberinput',
        values: [{
          'val': newViews
        }]
      });
      this.$api.editForm(this.query.fid, data.id, encodeURI(JSON.stringify(dataList)), data.formId).then(res => {});
    }
  }
};